import React from 'react'
import { daysMapping, monthMapping } from '../utils/dateMapping'

import classes from './spendDetails.module.css'
// import commonstyles from '../page/expenses.module.css'

function SpendDetails({ data }) {
  const getDateString = (datestring) => {
    const parsedDate = new Date(Number(datestring))
    const date = parsedDate.getDate()
    const day = daysMapping[parsedDate.getDay()]
    const month = monthMapping[parsedDate.getMonth()]

    return `${date} ${day} ${month}`
  }

  return (
    <div className={classes.spendingDetailsWrapper}>
      <p className={classes.header}>
        Spending Breakdown
      </p>
      {data.map((spend) => (
        <div key={spend.name} className={classes.spendingWrapper}>
          <div className={classes.icon}>
            <img src={`/icons/${spend.name.toLowerCase()}.svg`} alt="icon" />
          </div>
          <div className={classes.spendDetails}>
            <p className={classes.spendName}>{spend.name}</p>
            <p>{getDateString(spend.date)}</p>
          </div>
          <p className={classes.spendAmount}>
            {`- $${Number(spend.amount).toLocaleString()}`}
          </p>
        </div>
      ))}
    </div>
  )
}

export default SpendDetails
